import { ArrowLeft, Phone, Mail, MessageSquare, User } from "lucide-react";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-sarathi-background text-white">
      <div className="border-b border-white/10 bg-sarathi-surface/50 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3">
          <Link to="/" className="w-9 h-9 rounded-full bg-sarathi-background border border-white/10 flex items-center justify-center text-sarathi-text-muted hover:text-white transition-colors" data-testid="contact-back-btn">
            <ArrowLeft className="w-4 h-4" />
          </Link>
          <div className="flex items-center gap-2">
            <Phone className="w-5 h-5 text-sarathi-primary" />
            <h1 className="font-outfit text-lg font-semibold">Contact Us</h1>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-10 space-y-8" data-testid="contact-content">
        <div>
          <h2 className="font-outfit text-2xl font-bold">Get in Touch</h2>
          <p className="text-sarathi-text-muted text-sm mt-2">We'd love to hear from you. Reach out via phone, email, or WhatsApp.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Vishal Rao */}
          <div className="bg-sarathi-surface border border-white/10 rounded-xl p-5 space-y-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-sarathi-primary/10 rounded-lg flex items-center justify-center">
                <User className="w-5 h-5 text-sarathi-primary" />
              </div>
              <div>
                <p className="text-white font-semibold">Vishal Rao</p>
                <p className="text-sarathi-text-muted text-xs">Cofounder</p>
              </div>
            </div>
            <a href="tel:+918197166646" className="flex items-center gap-2 text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm pt-1">
              <Phone className="w-4 h-4" />
              +91 81971 66646
            </a>
          </div>

          {/* Sarathi-X Team */}
          <div className="bg-sarathi-surface border border-white/10 rounded-xl p-5 space-y-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-sarathi-primary/10 rounded-lg flex items-center justify-center">
                <Phone className="w-5 h-5 text-sarathi-primary" />
              </div>
              <div>
                <p className="text-white font-semibold">Sarathi-X Team</p>
                <p className="text-sarathi-text-muted text-xs">Booking support</p>
              </div>
            </div>
            <a href="tel:+919187057303" className="flex items-center gap-2 text-sarathi-text-secondary hover:text-sarathi-primary transition-colors text-sm pt-1">
              <Phone className="w-4 h-4" />
              +91 91870 57303
            </a>
          </div>

          {/* Ride enquiries */}
          <div className="bg-sarathi-surface border border-white/10 rounded-xl p-5 space-y-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-sarathi-primary/10 rounded-lg flex items-center justify-center">
                <Mail className="w-5 h-5 text-sarathi-primary" />
              </div>
              <div>
                <p className="text-white font-semibold">Ride Enquiries & Feedback</p>
              </div>
            </div>
            <a href="mailto:founder@sarathix.in" className="flex items-center gap-2 text-sarathi-primary hover:underline text-sm pt-1">
              <Mail className="w-4 h-4" />
              founder@sarathix.in
            </a>
          </div>

          {/* Everything else */}
          <div className="bg-sarathi-surface border border-white/10 rounded-xl p-5 space-y-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-sarathi-primary/10 rounded-lg flex items-center justify-center">
                <Mail className="w-5 h-5 text-sarathi-primary" />
              </div>
              <div>
                <p className="text-white font-semibold">Everything Else</p>
              </div>
            </div>
            <a href="mailto:founder@sarathix.in" className="flex items-center gap-2 text-sarathi-primary hover:underline text-sm pt-1">
              <Mail className="w-4 h-4" />
              founder@sarathix.in
            </a>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="bg-sarathi-surface border border-white/10 rounded-xl p-6 text-center space-y-3">
          <p className="text-white font-medium">Prefer WhatsApp?</p>
          <a
            href="https://wa.me/919187057303?text=Hi%2C%20I%20have%20a%20query%20about%20Sarathi-X."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 rounded-full px-6 py-2.5 text-[#25D366] text-sm font-medium hover:bg-[#25D366]/20 transition-colors"
            data-testid="contact-whatsapp-btn"
          >
            <MessageSquare className="w-4 h-4" />
            Chat with us on WhatsApp
          </a>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <Link to="/" className="text-sarathi-primary hover:underline text-sm font-medium" data-testid="contact-home-link">Back to Sarathi-X Home</Link>
        </div>
      </div>
    </div>
  );
}
